import React from 'react'
import PropTypes from 'prop-types'
import { ListGrid } from '@maui/elements'

const filter = 'opacity(0.30) brightness(0.75) grayscale(1)'

const DimmableBox = ({ dimmed, style, ...props }) => {
  style = {
    ...style,
    filter: dimmed ? filter : undefined
  }

  return (
    <ListGrid.Item style={style} {...props} />
  )
}

DimmableBox.propTypes = {
  dimmed: PropTypes.bool,
  style: PropTypes.object,
}

export { DimmableBox }
